import React from 'react';

import * as styles from './IconSeekPass.css';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 270.13 65.01"
    height="40"
    focusable="false"
    fill="currentColor"
  >
    <g>
      <g>
        <path
          d="M84.16,44.09c-3.7,0-7.04-0.41-10.01-3.38l3.83-3.83c1.94,1.94,4.47,2.21,6.27,2.21c2.03,0,4.15-0.67,4.15-2.43
                  c0-1.17-0.63-1.99-2.48-2.17l-3.7-0.36c-4.24-0.4-6.85-2.25-6.85-6.59c0-4.87,4.28-7.49,9.06-7.49c3.65,0,6.72,0.63,8.98,2.75
                  l-3.61,3.65c-1.35-1.22-3.43-1.58-5.46-1.58C82,24.87,81,25.95,81,27.12c0,0.86,0.36,1.85,2.44,2.03l3.7,0.36
                  c4.64,0.45,6.99,2.93,6.99,6.9C94.13,41.61,89.71,44.09,84.16,44.09z"
        />
        <path
          d="M102.07,33.9c0,3.02,1.85,5.23,5.14,5.23c2.57,0,3.83-0.72,5.32-2.21l3.56,3.47c-2.39,2.39-4.69,3.7-8.93,3.7
                  c-5.55,0-10.87-2.53-10.87-12.04c0-7.67,4.15-12,10.24-12c6.54,0,10.24,4.78,10.24,11.23v2.61h-14.7V33.9z M110.46,27.35
                  c-0.63-1.4-1.94-2.43-3.93-2.43c-1.99,0-3.29,1.04-3.92,2.43c-0.36,0.86-0.49,1.49-0.54,2.53H111
                  C110.95,28.85,110.82,28.21,110.46,27.35z"
        />
        <path
          d="M125.2,33.9c0,3.02,1.85,5.23,5.14,5.23c2.57,0,3.84-0.72,5.32-2.21l3.56,3.47c-2.39,2.39-4.69,3.7-8.93,3.7
                  c-5.55,0-10.87-2.53-10.87-12.04c0-7.67,4.15-12,10.24-12c6.54,0,10.24,4.78,10.24,11.23v2.61h-14.7V33.9z M133.59,27.35
                  c-0.63-1.4-1.94-2.43-3.92-2.43c-1.99,0-3.29,1.04-3.93,2.43c-0.36,0.86-0.5,1.49-0.54,2.53h8.93
                  C134.09,28.85,133.95,28.21,133.59,27.35z"
        />
        <path d="M157.86,43.82l-5.77-9.79l-2.49,2.8v6.99h-5.86V11.7h5.86v18.22l7.8-9.61h7.08l-8.39,9.47l9.02,14.03h-7.25V43.82z" />
      </g>
      <path
        className={styles.logoBackground}
        d="M0,32.51C0,14.55,14.55,0,32.51,0s32.51,14.55,32.51,32.51c0,17.95-14.55,32.5-32.51,32.5S0,50.46,0,32.51
              L0,32.51z"
      />
      <path
        className={styles.logoDots}
        d="M33.27,12.4c0-1.12,0.91-2.03,2.03-2.03c1.13,0,2.03,0.91,2.03,2.03s-0.91,2.03-2.03,2.03
              C34.18,14.43,33.27,13.52,33.27,12.4L33.27,12.4z"
      />
      <path
        className={styles.logoDots}
        d="M39.59,19.23c0-1.24,1-2.24,2.24-2.24s2.24,1,2.24,2.24s-1,2.24-2.24,2.24
              C40.6,21.47,39.59,20.46,39.59,19.23L39.59,19.23z"
      />
      <path
        className={styles.logoDots}
        d="M33.27,19.23c0-1.12,0.91-2.03,2.03-2.03c1.13,0,2.03,0.91,2.03,2.03s-0.91,2.03-2.03,2.03
              C34.18,21.26,33.27,20.35,33.27,19.23L33.27,19.23z"
      />
      <path
        className={styles.logoDots}
        d="M46.32,26.08c0-1.39,1.12-2.52,2.52-2.52c1.39,0,2.51,1.12,2.51,2.52c0,1.39-1.12,2.51-2.51,2.51
              C47.45,28.6,46.32,27.47,46.32,26.08L46.32,26.08z"
      />
      <path
        className={styles.logoDots}
        d="M39.59,26.06c0-1.24,1-2.24,2.24-2.24s2.24,1,2.24,2.24s-1,2.24-2.24,2.24C40.6,28.3,39.59,27.3,39.59,26.06
              L39.59,26.06z"
      />
      <path
        className={styles.logoDots}
        d="M33.27,26.06c0-1.12,0.91-2.03,2.03-2.03c1.13,0,2.03,0.91,2.03,2.03s-0.91,2.03-2.03,2.03
              C34.18,28.09,33.27,27.18,33.27,26.06L33.27,26.06z"
      />
      <path
        className={styles.logoDots}
        d="M27.23,26.06c0-0.98,0.79-1.78,1.78-1.78c0.98,0,1.78,0.79,1.78,1.78c0,0.98-0.79,1.78-1.78,1.78
              C28.03,27.84,27.23,27.04,27.23,26.06L27.23,26.06z"
      />
      <path
        className={styles.logoDots}
        d="M22.2,26.06c0-0.84,0.68-1.53,1.52-1.53s1.52,0.68,1.52,1.53s-0.68,1.52-1.52,1.52S22.2,26.9,22.2,26.06
              L22.2,26.06z"
      />
      <path
        className={styles.logoDots}
        d="M17.4,26.06c0-0.7,0.57-1.27,1.27-1.27s1.27,0.57,1.27,1.27s-0.57,1.27-1.27,1.27S17.4,26.76,17.4,26.06
              L17.4,26.06z"
      />
      <path
        className={styles.logoDots}
        d="M13.34,26.06c0-0.56,0.46-1.02,1.02-1.02s1.02,0.45,1.02,1.02c0,0.56-0.46,1.01-1.02,1.01
              C13.79,27.07,13.34,26.62,13.34,26.06L13.34,26.06z"
      />
      <path
        className={styles.logoDots}
        d="M9.49,26.06c0-0.42,0.34-0.76,0.76-0.76s0.76,0.34,0.76,0.76s-0.34,0.76-0.76,0.76S9.49,26.48,9.49,26.06
              L9.49,26.06z"
      />
      <path
        className={styles.logoDots}
        d="M6.24,26.06c0-0.28,0.23-0.51,0.51-0.51s0.5,0.23,0.5,0.51s-0.23,0.51-0.5,0.51
              C6.47,26.57,6.24,26.34,6.24,26.06L6.24,26.06z"
      />
      <path
        className={styles.logoDots}
        d="M46.32,32.91c0-1.39,1.12-2.52,2.52-2.52c1.39,0,2.51,1.13,2.51,2.52s-1.12,2.51-2.51,2.51
              C47.45,35.42,46.32,34.3,46.32,32.91L46.32,32.91z"
      />
      <path
        className={styles.logoDots}
        d="M39.59,32.89c0-1.24,1-2.24,2.24-2.24s2.24,1,2.24,2.24s-1,2.24-2.24,2.24
              C40.6,35.13,39.59,34.13,39.59,32.89L39.59,32.89z"
      />
      <path
        className={styles.logoDots}
        d="M33.27,32.89c0-1.12,0.91-2.03,2.03-2.03c1.13,0,2.03,0.91,2.03,2.03s-0.91,2.03-2.03,2.03
              C34.18,34.92,33.27,34.01,33.27,32.89L33.27,32.89z"
      />
      <path
        className={styles.logoDots}
        d="M27.23,32.89c0-0.98,0.79-1.78,1.78-1.78c0.98,0,1.78,0.79,1.78,1.78c0,0.98-0.79,1.78-1.78,1.78
              C28.03,34.67,27.23,33.87,27.23,32.89L27.23,32.89z"
      />
      <path
        className={styles.logoDots}
        d="M22.2,32.89c0-0.84,0.68-1.52,1.52-1.52s1.52,0.68,1.52,1.52s-0.68,1.52-1.52,1.52S22.2,33.73,22.2,32.89
              L22.2,32.89z"
      />
      <path
        className={styles.logoDots}
        d="M17.4,32.89c0-0.7,0.57-1.27,1.27-1.27s1.27,0.57,1.27,1.27s-0.57,1.27-1.27,1.27S17.4,33.59,17.4,32.89
              L17.4,32.89z"
      />
      <path
        className={styles.logoDots}
        d="M13.34,32.89c0-0.56,0.46-1.02,1.02-1.02s1.02,0.45,1.02,1.02c0,0.56-0.46,1.01-1.02,1.01
              C13.79,33.9,13.34,33.45,13.34,32.89L13.34,32.89z"
      />
      <path
        className={styles.logoDots}
        d="M9.49,32.89c0-0.42,0.34-0.76,0.76-0.76s0.76,0.34,0.76,0.76s-0.34,0.76-0.76,0.76
              C9.83,33.65,9.49,33.31,9.49,32.89L9.49,32.89z"
      />
      <path
        className={styles.logoDots}
        d="M6.24,32.89c0-0.28,0.23-0.51,0.51-0.51s0.5,0.23,0.5,0.51s-0.23,0.51-0.5,0.51
              C6.47,33.4,6.24,33.17,6.24,32.89L6.24,32.89z"
      />
      <path
        className={styles.logoDots}
        d="M53.22,32.96c0-1.52,1.24-2.76,2.76-2.76c1.52,0,2.75,1.23,2.75,2.76c0,1.52-1.23,2.75-2.75,2.75
              C54.46,35.71,53.22,34.48,53.22,32.96L53.22,32.96z"
      />
      <path
        className={styles.logoDots}
        d="M46.32,39.74c0-1.39,1.12-2.52,2.52-2.52c1.39,0,2.51,1.13,2.51,2.52s-1.12,2.52-2.51,2.52
              C47.45,42.26,46.32,41.13,46.32,39.74L46.32,39.74z"
      />
      <path
        className={styles.logoDots}
        d="M39.59,39.72c0-1.24,1-2.24,2.24-2.24s2.24,1,2.24,2.24c0,1.24-1,2.24-2.24,2.24
              C40.6,41.96,39.59,40.96,39.59,39.72L39.59,39.72z"
      />
      <path
        className={styles.logoDots}
        d="M33.27,39.72c0-1.12,0.91-2.03,2.03-2.03c1.13,0,2.03,0.91,2.03,2.03c0,1.12-0.91,2.03-2.03,2.03
              C34.18,41.75,33.27,40.84,33.27,39.72L33.27,39.72z"
      />
      <path
        className={styles.logoDots}
        d="M27.23,39.72c0-0.98,0.79-1.78,1.78-1.78c0.98,0,1.78,0.8,1.78,1.78c0,0.98-0.79,1.78-1.78,1.78
              C28.03,41.5,27.23,40.7,27.23,39.72L27.23,39.72z"
      />
      <path
        className={styles.logoDots}
        d="M22.2,39.72c0-0.84,0.68-1.52,1.52-1.52s1.52,0.68,1.52,1.52c0,0.84-0.68,1.52-1.52,1.52
              C22.88,41.24,22.2,40.56,22.2,39.72L22.2,39.72z"
      />
      <path
        className={styles.logoDots}
        d="M17.4,39.72c0-0.71,0.57-1.27,1.27-1.27s1.27,0.56,1.27,1.27c0,0.7-0.57,1.27-1.27,1.27
              C17.97,40.99,17.4,40.42,17.4,39.72L17.4,39.72z"
      />
      <path
        className={styles.logoDots}
        d="M13.34,39.72c0-0.56,0.46-1.02,1.02-1.02s1.02,0.46,1.02,1.02c0,0.56-0.46,1.02-1.02,1.02
              C13.79,40.74,13.34,40.28,13.34,39.72L13.34,39.72z"
      />
      <path
        className={styles.logoDots}
        d="M9.49,39.72c0-0.42,0.34-0.76,0.76-0.76s0.76,0.34,0.76,0.76s-0.34,0.76-0.76,0.76S9.49,40.14,9.49,39.72
              L9.49,39.72z"
      />
      <path
        className={styles.logoDots}
        d="M6.24,39.72c0-0.28,0.23-0.51,0.51-0.51s0.5,0.23,0.5,0.51s-0.23,0.5-0.5,0.5C6.47,40.22,6.24,40,6.24,39.72
              L6.24,39.72z"
      />
      <path
        className={styles.logoDots}
        d="M39.59,46.55c0-1.24,1-2.24,2.24-2.24s2.24,1,2.24,2.24s-1,2.24-2.24,2.24
              C40.6,48.79,39.59,47.79,39.59,46.55L39.59,46.55z"
      />
      <path
        className={styles.logoDots}
        d="M33.27,46.55c0-1.12,0.91-2.04,2.03-2.04c1.13,0,2.03,0.91,2.03,2.04c0,1.12-0.91,2.03-2.03,2.03
              C34.18,48.58,33.27,47.67,33.27,46.55L33.27,46.55z"
      />
      <path
        className={styles.logoDots}
        d="M33.27,53.38c0-1.12,0.91-2.03,2.03-2.03c1.13,0,2.03,0.91,2.03,2.03c0,1.12-0.91,2.03-2.03,2.03
              C34.18,55.41,33.27,54.5,33.27,53.38L33.27,53.38z"
      />
    </g>
    <g>
      <path
        d="M191.64,44.72c-4.45,0-7.33-2.25-9.27-5.31v16.78h-3.51V20.33h3.46v5.22c1.93-3.02,4.77-5.62,9.31-5.62
          c6.84,0,11.29,6.12,11.29,12.37C202.93,38.78,198.48,44.72,191.64,44.72z M190.92,41.61c5.31,0,8.41-4.14,8.41-9.22
          c0-4.99-3.1-9.36-8.41-9.36c-4.95,0-8.59,4.41-8.59,9.22C182.32,37.2,185.83,41.61,190.92,41.61z"
      />
      <path
        d="M216.61,23.03c-3.69,0-5.71,2.21-6.88,4.72l-2.88-1.62c1.67-3.83,4.99-6.21,9.85-6.21c5.08,0,7.6,2.29,8.77,4.95
          c0.54,1.31,0.72,3.19,0.72,3.96v15.52h-3.42v-4.23h-0.04c-1.89,2.97-4.5,4.63-8.1,4.63c-4.86,0-8.05-3.01-8.05-7.06v-0.27
          c0-5.22,5.22-6.93,9.49-6.93h6.66v-1.62C222.73,25.01,220.62,23.03,216.61,23.03z M215.26,41.66c4.27,0,7.47-3.02,7.47-7.42v-0.85
          h-6.7c-2.56,0-5.94,0.81-5.94,4.05C210.09,40.13,212.38,41.66,215.26,41.66z"
      />
      <path
        d="M240.19,44.76c-4.86,0-7.74-2.47-9.4-6.21l2.88-1.58c1.12,2.39,2.88,4.68,6.48,4.68c2.61,0,5.13-1.4,5.13-3.92
          c0-2.11-1.75-3.1-6.03-4.09c-3.19-0.72-4.9-1.44-6.25-2.97c-0.85-0.99-1.3-2.25-1.3-3.6c0-4.36,4.32-7.15,8.37-7.15
          c4.77,0,7.2,2.61,8.5,5.58l-2.88,1.57c-1.08-2.29-2.61-4.05-5.62-4.05c-2.61,0-4.86,1.71-4.86,3.78c0,1.98,1.17,2.83,5.62,3.78
          c2.92,0.63,4.86,1.48,6.3,2.97c1.04,1.03,1.71,2.38,1.71,3.96C248.83,41.7,245.14,44.76,240.19,44.76z"
      />
      <path
        d="M261.48,44.76c-4.86,0-7.74-2.47-9.4-6.21l2.88-1.58c1.12,2.39,2.88,4.68,6.48,4.68c2.61,0,5.13-1.4,5.13-3.92
          c0-2.11-1.75-3.1-6.03-4.09c-3.19-0.72-4.9-1.44-6.25-2.97c-0.85-0.99-1.3-2.25-1.3-3.6c0-4.36,4.32-7.15,8.37-7.15
          c4.77,0,7.2,2.61,8.5,5.58l-2.88,1.57c-1.08-2.29-2.61-4.05-5.62-4.05c-2.61,0-4.86,1.71-4.86,3.78c0,1.98,1.17,2.83,5.62,3.78
          c2.92,0.63,4.86,1.48,6.3,2.97c1.04,1.03,1.71,2.38,1.71,3.96C270.12,41.7,266.43,44.76,261.48,44.76z"
      />
    </g>
  </svg>
);
